import React from 'react';

import { ThemeConfig } from '../themes';
import { makeLogoStyles, makeNavStyles, makeNavDrawerStyles } from './NavBar';
import NavBar from './NavBar';


const useLogoStyles = makeLogoStyles( theme  => ({
  // layout specific styles here
}));

const useNavStyles = makeNavStyles( theme  => ({
  root: {
    verticalAlign: 'middle',
    padding: '20px 0 0 10px',
    height: '100px',
  },
  linkContainer: {
    position: 'absolute',
    right: '20px',
    top: '30%',
  },
  link: {
    textDecoration: 'none',
    fontWeight: '500',
  }
}));

const useNavDrawerStyles = makeNavDrawerStyles( (theme: ThemeConfig) => ({
  // layout specific styles here
}));


export default function AppBar() {
  const logoClasses = useLogoStyles();
  const navClasses = useNavStyles();
  const navDrawerClasses = useNavDrawerStyles();

  return <NavBar {...{navClasses, navDrawerClasses, logoClasses}} />;
}

AppBar.propTypes = {
};